import { Box, Grid, MenuItem, Select, TextField } from "@mui/material";
import * as React from "react";
import { AvatarImage } from "ui/Scripts/source/components/framework/Avatar/AvatarImage";
import { Base } from "ui/Scripts/source/framework/base";
import { IIdTitle, IdTitle } from "ui/Scripts/source/models/common/idTitle";
import { EnumHelper, RecordEmployeeType } from "ui/Scripts/source/models/enums";
import { Translations } from "ui/Scripts/source/models/translations";
import * as store from "../../../framework/customStore";
import { IRecordEditItem } from "../../../models/record/recordEditItem";
import * as storeActions from "../../../models/store/storeActions";
import { DatePicker } from "../../framework/DateTime/DatePicker";
import { Autocomplete } from "../../framework/Form/Autocomplete";
import { TextFieldWithButtonGroup } from "../../framework/Form/TextFieldWithButtonGroup";
import { FormField } from "../../../../../../QTeamSystems.QTeamIntra.Ui/Scripts/source/components/framework/FormField";
import { GridRow } from "../../framework/Grid/GridRow";
import { ModifyUserInfo } from "../../framework/User/ModifyUserInfo";

export interface IRecordEditBasicInformationProp {
    onDialog: boolean;
    canReadUsers: boolean;
    canEditUsers: boolean;
    canClearUnit: boolean;
    canArchiveAndRemove: boolean;
    isPartnerCompanyRecord: boolean;
    resetPicture: boolean;
    record: IRecordEditItem;
    workShiftNames: string[];
    // General
    unitCode: string;
    userCode: string;
    firstName: string;
    middleName: string;
    lastName: string;
    picture: string;
    birthDate: string;
    postalAddress: string;
    postalCode: string;
    city: string;
    phone: string;
    email: string;
    employeeType: RecordEmployeeType;
    ibanNumber: string;
    bicCode: string;
    taxNumber: string;
    driversLicenseType: string;
    workShiftName: string;
    comment: string;
    activeState: number;
    personalIdentityCode: string;
    identifier: string;
    onChange: (name: string, value: string) => void;
    onBlur: (name: string, value: string) => void;
    onChangePicture: (file: File) => void;
    onRemovePicture: () => void;
    onAddUser: () => void;
    onEditUser: () => void;
    onSelectUser: () => void;
    onRemoveUser: () => void;
    onSelectUnit: () => void;
    onRemoveUnit: () => void;
}

export interface IRecordEditBasicInformationState {
    workShiftNames: IIdTitle[];
}

export class RecordEditBasicInformation extends React.Component<IRecordEditBasicInformationProp, IRecordEditBasicInformationState> {
    getStateFromProps = (props: IRecordEditBasicInformationProp): IRecordEditBasicInformationState => {
        const workShiftNames = props.workShiftNames.slice(0);
        workShiftNames.sort(Base.strCompare);
        return {
            workShiftNames: workShiftNames.map(i => IdTitle.createIdTitleSimple(i))
        };
    };
    
    constructor(props: IRecordEditBasicInformationProp) {
        super(props);
        this.state = this.getStateFromProps(props);
    }

    async componentDidUpdate(prevProps: IRecordEditBasicInformationProp, prevState: IRecordEditBasicInformationState) {
        const props = this.props;
        if (Base.equalStrArrays(prevProps.workShiftNames, props.workShiftNames)) return;
        const state = this.getStateFromProps(props);
        this.setState(state);
    }

    handleChange = (event) => {
        const target = event.target;
        this.props.onChange(target.name !== "xts" ? target.name : "code", target.value);
    };

    handleBlur = (event) => {
        const target = event.target;
        this.props.onBlur(target.name !== "xts" ? target.name : "code", target.value);
    };
   
    render() {
        const props = this.props;
        const state = this.state;
        const record = props.record;
        if (!record) return null;
        const isNew = record.isNew();
        return (
            <>
                <GridRow>
                    <Grid item sm={12} xl={6}>
                        <GridRow>
                            <Grid item sm={12}>
                                <Box display="flex" alignItems="flex-end">
                                    <AvatarImage
                                        size={60}
                                        marginRight={"1rem"}
                                        id={props.userCode}
                                        name={props.lastName + " " + props.firstName}
                                        image={props.picture}
                                        editable={true}
                                        tooltip={Translations.CkickToChangeThePicture}
                                        removeTooltip={Translations.RemovePicture}
                                        onChange={props.onChangePicture}
                                        onClear={props.resetPicture ? null : props.onRemovePicture}
                                        onError={(message) => { store.customStore.dispatch(storeActions.showErrorMessage(message)); }}
                                    />
                                    <GridRow>
                                        <Grid item xs>
                                            <FormField title={Translations.FirstName} required margin={0}>
                                                <TextField type="text" name="firstName" title={Translations.FirstName} inputProps={{ maxLength: 50 }} value={props.firstName} onChange={this.handleChange} />
                                            </FormField>
                                        </Grid>
                                        <Grid item xs>
                                            <FormField title={Translations.LastName} required margin={0}>
                                                <TextField type="text" name="lastName" title={Translations.LastName} inputProps={{ maxLength: 50 }} value={props.lastName} onChange={this.handleChange} />
                                            </FormField>
                                        </Grid>
                                        <Grid item xs>
                                            <FormField title={Translations.MiddleName} margin={0}>
                                                <TextField type="text" name="middleName" title={Translations.MiddleName} inputProps={{ maxLength: 50 }} value={props.middleName} onChange={this.handleChange} />
                                            </FormField>
                                        </Grid>
                                    </GridRow>
                                </Box>
                            </Grid>
                        </GridRow>
                        <GridRow>
                            <Grid item xs>
                                <FormField title={Translations.PostalAddress}>
                                    <TextField type="text" name="postalAddress" title={Translations.PostalAddress} inputProps={{ maxLength: 50 }} disabled={false} value={props.postalAddress} onChange={this.handleChange} />
                                </FormField>
                            </Grid>
                        </GridRow>
                        <GridRow>
                            <Grid item sm={12} md={4}>
                                <FormField title={Translations.PostalCode}>
                                    <TextField type="text" name="postalCode" title={Translations.PostalCode} inputProps={{ maxLength: 10 }} disabled={false} value={props.postalCode} onChange={this.handleChange} />
                                </FormField>
                            </Grid>
                            <Grid item sm={12} md={8}>
                                <FormField title={Translations.City}>
                                    <TextField type="text" name="city" title={Translations.City} inputProps={{ maxLength: 50 }} disabled={false} value={props.city} onChange={this.handleChange} />
                                </FormField>
                            </Grid>
                        </GridRow>
                        <GridRow>
                            <Grid item sm={4}>
                                <FormField title={Translations.Phone}>
                                    <TextField type="text" name="phone" title={Translations.Phone} inputProps={{ maxLength: 50 }} disabled={false} value={props.phone} onChange={this.handleChange} />
                                </FormField>
                            </Grid>
                            <Grid item sm={8}>
                                <FormField title={Translations.EmailAddress}>
                                    <TextField type="text" name="email" title={Translations.EmailAddress} inputProps={{ maxLength: 50 }} disabled={false} value={props.email} onChange={this.handleChange} />
                                </FormField>
                            </Grid>
                        </GridRow>
                        <GridRow>
                            <Grid item sm={4}>
                                <FormField title={Translations.BirthDate}>
                                    <DatePicker
                                        value={props.birthDate}
                                        onChange={(value: string) => props.onChange("birthDate", value)}
                                    />
                                </FormField>
                            </Grid>
                            <Grid item sm={8}>
                                <FormField title={Translations.PersonalIdentityCode}>
                                    <TextField type="text" name="personalIdentityCode" title={Translations.PersonalIdentityCode} inputProps={{ maxLength: 11 }} value={props.personalIdentityCode} onChange={this.handleChange} />
                                </FormField>
                            </Grid>
                        </GridRow>
                        <GridRow>
                            <Grid item sm={4}>
                                <FormField title={Translations.Identifier}>
                                    <TextField type="text" name="identifier" title={Translations.Identifier} inputProps={{ maxLength: 50 }} value={props.identifier} onChange={this.handleChange} />
                                </FormField>
                            </Grid>
                            <Grid item sm={8}>
                                <FormField title={Translations.TaxNumber}>
                                    <TextField type="text" name="taxNumber" title={Translations.TaxNumber} inputProps={{ maxLength: 12 }} value={props.taxNumber} onChange={this.handleChange} />
                                </FormField>
                            </Grid>
                        </GridRow>
                        <GridRow>
                            <Grid item sm={4}>
                                <FormField title={Translations.BankBICCode}>
                                    <TextField type="text" name="bicCode" title={Translations.BankBICCode} inputProps={{ maxLength: 11 }} value={props.bicCode} onChange={this.handleChange} />
                                </FormField>
                            </Grid>
                            <Grid item sm={8}>
                                <FormField title={Translations.AccountIBANNumber}>
                                    <TextField type="text" name="ibanNumber" title={Translations.AccountIBANNumber} inputProps={{ maxLength: 35 }} value={props.ibanNumber} onChange={this.handleChange} onBlur={this.handleBlur} />
                                </FormField>
                            </Grid>
                        </GridRow>
                        {/* {props.onDialog &&
                            <GridRow>
                                <Grid item xs>
                                    <FormField title="">
                                        <FormControlLabel
                                            label={Translations.Archived}
                                            control={
                                                <Checkbox
                                                    checked={props.activeState < 0.5}
                                                    disabled={!props.canArchiveAndRemove}
                                                    onChange={(_e, checked: boolean) => props.onChange("activeState", checked ? "0" : "1")}
                                                />
                                            }
                                        />
                                    </FormField>
                                </Grid>
                            </GridRow>
                        } */}
                    </Grid>
                    <Grid item sm={12} xl={6}>
                        <GridRow>
                            <Grid item sm={props.onDialog ? 12 : 6}>
                                <FormField title={Translations.User} margin={0}>
                                    <TextFieldWithButtonGroup
                                        type="text"
                                        name="userCode"
                                        title={Translations.UserName}
                                        disabled={true}
                                        value={props.userCode}
                                        showButtons={props.onDialog && (props.canEditUsers || props.canReadUsers)}
                                        buttons={[
                                            { label: Translations.AddNew, onClick: props.onAddUser, hidden: props.isPartnerCompanyRecord || !props.canEditUsers || !!props.userCode },
                                            { label: Translations.Edit, onClick: props.onEditUser, hidden: props.isPartnerCompanyRecord || !props.canEditUsers || !props.userCode },
                                            { label: Translations.Select, onClick: props.onSelectUser, hidden: props.isPartnerCompanyRecord || !props.canReadUsers },
                                            { label: Translations.Remove, onClick: props.onRemoveUser, hidden: props.isPartnerCompanyRecord || !props.canReadUsers || !props.userCode },
                                        ]}
                                    />
                                </FormField>
                            </Grid>
                            <Grid item sm={props.onDialog ? 12 : 6}>
                                <FormField title={Translations.Unit} margin=".4rem 0 0 0">
                                    <TextFieldWithButtonGroup
                                        type="text"
                                        name="unitCode"
                                        title={Translations.Unit}
                                        disabled={true}
                                        value={props.unitCode}
                                        showButtons={props.onDialog}
                                        buttons={[
                                            { label: Translations.Select, onClick: props.onSelectUnit, hidden: props.isPartnerCompanyRecord },
                                            { label: Translations.Remove, onClick: props.onRemoveUnit, hidden: !props.canClearUnit || !props.unitCode || props.isPartnerCompanyRecord },
                                        ]}
                                    />
                                </FormField>
                            </Grid>
                        </GridRow>
                        <GridRow>
                            <Grid item sm={6}>
                                <FormField title={Translations.DriversLicenseType}>
                                    <TextField type="text" name="driversLicenseType" title={Translations.DriversLicenseType} inputProps={{ maxLength: 50 }} value={props.driversLicenseType} onChange={this.handleChange} />
                                </FormField>
                            </Grid>
                            <Grid item sm={6}>
                                <FormField title={Translations.EmployeeType} required>
                                    <Select name="employeeType" title={Translations.EmployeeType} value={props.employeeType.toString(10)} onChange={this.handleChange}>
                                        <MenuItem key={99} value="99">{"'" + Translations.Select + "'"}</MenuItem>
                                        <MenuItem key={RecordEmployeeType.Intern} value={RecordEmployeeType.Intern.toString(10)}>{EnumHelper.RecordEmployeeTypeToStr(RecordEmployeeType.Intern)}</MenuItem>
                                        <MenuItem key={RecordEmployeeType.Employee} value={RecordEmployeeType.Employee.toString(10)}>{EnumHelper.RecordEmployeeTypeToStr(RecordEmployeeType.Employee)}</MenuItem>
                                        <MenuItem key={RecordEmployeeType.AgencyWorker} value={RecordEmployeeType.AgencyWorker.toString(10)}>{EnumHelper.RecordEmployeeTypeToStr(RecordEmployeeType.AgencyWorker)}</MenuItem>
                                        <MenuItem key={RecordEmployeeType.SeasonalWorker} value={RecordEmployeeType.SeasonalWorker.toString(10)}>{EnumHelper.RecordEmployeeTypeToStr(RecordEmployeeType.SeasonalWorker)}</MenuItem>
                                        <MenuItem key={RecordEmployeeType.Entrepreneur} value={RecordEmployeeType.Entrepreneur.toString(10)}>{EnumHelper.RecordEmployeeTypeToStr(RecordEmployeeType.Entrepreneur)}</MenuItem>
                                        <MenuItem key={RecordEmployeeType.Other} value={RecordEmployeeType.Other.toString(10)}>{EnumHelper.RecordEmployeeTypeToStr(RecordEmployeeType.Other)}</MenuItem>
                                    </Select>
                                </FormField>
                            </Grid>
                        </GridRow>
                        <GridRow>
                            <Grid item xs>
                                <FormField title={Translations.WorkShift}>
                                    <Autocomplete
                                        value={props.workShiftName}
                                        maxLength={100}
                                        options={state.workShiftNames}
                                        onChange={(value: string) => props.onChange("workShiftName", value)}
                                    />
                                </FormField>
                            </Grid>
                        </GridRow>
                        <GridRow>
                            <Grid item xs>
                                <FormField title={Translations.AdditionalInformation}>
                                    <TextField name="comment" title={Translations.AdditionalInformation} inputProps={{ maxLength: 1000 }} value={props.comment} onChange={this.handleChange} multiline minRows={5} />
                                </FormField>
                            </Grid>
                        </GridRow>
                        {(!isNew && !props.onDialog) &&
                            <GridRow>
                                <Grid item xs>
                                    <FormField title={Translations.Modified}>
                                        <ModifyUserInfo
                                            modifyUser={props.record.modifyUser}
                                        />
                                    </FormField>
                                </Grid>
                            </GridRow>
                        }
                    </Grid>
                </GridRow>
            </>
        );
    }
}